export default __webpack_public_path__ + "static/media/prices.a6ed7a07.svg";